<!-- <p>analytics-information-dialog works!</p> -->
<div
  [ngClass]="{
    'analytics-container': true,
    mobile: screenSize === ScreenType.Mobile
  }"
>
  <div
    class="analytics-header"
    [ngClass]="{ mobile: screenSize === ScreenType.Mobile }"
  >
    <h2>Risk Profiling Questions</h2>
    <!-- <button mat-mini-fab mat-dialog-close aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button> -->
  </div>
  <section *ngIf="!isDataLoaded">
    <div style="display: flex; justify-content: center">
      <mat-spinner> </mat-spinner>
      Loading...
    </div>
  </section>
  <div class="edit-risk-questions" *ngIf="riskAnalyticsData?.length > 0">
    <button
      mat-raised-button
      *ngIf="!isEditMode"
      (click)="enableEditMode()"
      color="accent"
    >
      Edit
    </button>

    <div *ngIf="isEditMode" class="edit-mode-actions">
      <button mat-raised-button (click)="cancelEdit()" class="cancel-button">
        Cancel
      </button>
    </div>
  </div>

  <div *ngIf="isDataLoaded" class="progress-indicator">
    <div
      class="progress-indicator-wrapper"
      [ngClass]="{ mobile: screenSize === ScreenType.Mobile }"
    >
      <span
        >Question {{ currentStep + 1 }} of {{ riskQuestionsForms.length }}</span
      >
      <!-- <mat-progress-bar
        [value]="((currentStep + 1) / riskQuestionsForms.length) * 100"
      >
      </mat-progress-bar> -->
      <mat-progress-bar
        [value]="(getAnsweredCount() / riskQuestionsForms.length) * 100"
      ></mat-progress-bar>
    </div>
  </div>

  <div
    *ngIf="isDataLoaded"
    class="analytics-content"
    [ngClass]="{
      mobile: screenSize === ScreenType.Mobile,
      'view-only': isFormDisabled()
    }"
  >
    <div class="analytics-expansion-wrapper">
      <form
        *ngFor="let formGroup of riskQuestionsForms; let i = index"
        [formGroup]="formGroup"
      >
        <mat-accordion>
          <mat-expansion-panel
            [expanded]="currentStep === i"
            (opened)="setStep(i)"
            [hideToggle]="true"
            class="risk-question-panel"
            [ngClass]="{ 'disabled-panel': isFormDisabled() }"
          >
            <mat-expansion-panel-header class="panel-header">
              <mat-panel-title class="panel-title">
                {{ formGroup.get("title")?.value }}
              </mat-panel-title>

              <mat-panel-description class="panel-status">
                <div
                  class="status-indicator"
                  [ngClass]="{
                    valid: !isFormInvalid(i),
                    invalid: isFormInvalid(i),
                    'view-only': isFormDisabled()
                  }"
                >
                  <mat-icon>{{
                    isFormInvalid(i) ? "error_outline" : "check_circle"
                  }}</mat-icon>
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="expansion-panel-content">
              <!-- Criticality Selection -->
              <div class="form-field">
                <div class="field-label">Criticality</div>
                <div class="field-input">
                  <mat-radio-group
                    formControlName="criticality"
                    aria-label="Select risk criticality"
                    class="risk-radio-group"
                    [class.disabled-input]="isFormDisabled()"
                  >
                    <mat-radio-button
                      *ngFor="let option of riskLevelOptions"
                      [value]="option.value"
                      class="risk-radio-button"
                      [disabled]="formGroup.get('criticality')?.disabled"
                    >
                      {{ option.label }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>

              <mat-divider></mat-divider>

              <!-- Frequency Input -->
              <div class="form-field">
                <div class="field-label">Question</div>
                <div class="field-input question-field">
                  <span
                    >How many do you think would have occurred in the last
                    month?</span
                  >
                  <mat-form-field
                    appearance="outline"
                    class="frequency-input"
                    [class.disabled-input]="isFormDisabled()"
                    subscriptSizing="dynamic"
                  >
                    <input
                      matInput
                      type="number"
                      min="0"
                      formControlName="frequency"
                      placeholder="Number"
                      [readonly]="formGroup.get('frequency')?.disabled"
                    />
                    <!-- <mat-error *ngIf="formGroup.get('frequency')?.invalid">
                      Please enter a valid number
                    </mat-error> -->
                  </mat-form-field>
                </div>
              </div>

              <mat-divider></mat-divider>

              <!-- Total Score -->
              <div class="form-field">
                <div class="field-label">Total</div>
                <div class="field-input total-score">
                  {{
                    formGroup.get("criticality")?.value *
                      formGroup.get("frequency")?.value
                  }}
                </div>
              </div>
            </div>

            <!-- Navigation Actions -->
            <mat-action-row>
              <button
                mat-button
                *ngIf="currentStep > 0"
                (click)="prevStep()"
                class="nav-button prev-button"
                [disabled]="isFormDisabled()"
              >
                Previous
              </button>
              <span class="spacer"></span>
              <button
                mat-button
                *ngIf="currentStep < riskQuestionsForms.length - 1"
                [disabled]="formGroup.invalid || isFormDisabled()"
                (click)="nextStep()"
                class="nav-button next-button"
              >
                Next Question
              </button>
            </mat-action-row>
          </mat-expansion-panel>
        </mat-accordion>
      </form>
    </div>

    <!-- Risk Summary -->
    <!-- <div
      class="risk-summary"
      *ngIf="currentStep === riskQuestionsForms.length - 1"
    >
      <h3>Risk Assessment Summary</h3>
      <div class="summary-score">
        <span>Total Risk Score: </span>
        <strong>{{ getTotalRiskScore() }}</strong>
      </div>
    </div> -->

    <!-- Dialog Actions -->
    <div class="analytics-action">
      <button
        mat-raised-button
        color="primary"
        [disabled]="!isAllAnswered || isFormDisabled()"
        (click)="saveAnswers()"
        class="save-button"
      >
        {{ isEditMode ? "Save Changes" : "Save Answers" }}
      </button>
    </div>
  </div>
</div>
